import { GLOBAL_SELECTORS_KEYS } from 'features/command-center/constants';
import { userHasRoles } from 'services/Authorization';
import { Roles } from 'UI/constants/roles';
import { loadFromLocalStorage } from 'UI/utils';

export const getRegionalInitialState = user => {
  const isRegional = userHasRoles([Roles.RegionalDirector]);
  const isAssistantRegionalDirector = userHasRoles([Roles.AssistantRegionalDirector]);

  if (!isAssistantRegionalDirector && !isRegional)
    return loadFromLocalStorage(GLOBAL_SELECTORS_KEYS.dominate.regional, null);

  return {
    email: user.email,
    full_name: user.personalInformation.full_name,
    id: isRegional ? user.id : user?.teamRelation?.regionalDirectorId,
    initials: user.initials
  };
};
